import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import InstallerPackCard from "../../components/InstallerPackCard/InstallerPackCard";
import InstallerPackField from "../../components/InstallerPackField/InstallerPackField";
import HealthSafetyCard from "../../components/HealthSafetyCard/HealthSafetyCard";
import HealthSafetyTemplate from "../../components/HealthSafetyTemplate/HealthSafetyTemplate";
import InstallerPackCustomerDetailsPhotos from "../../components/InstallerPackCustomerDetailsPhotos/InstallerPackCustomerDetailsPhotos";
import PhoneField from "../../components/PhoneField/PhoneField";
import InstallerPackPhotos from "../../components/InstallerPackPhotos/InstallerPackPhotos";

import "./installerPack.css";

function InstallerPack() {
  const [installerPack, setInstallerPack] = useState();
  const { id, lsui } = useParams();
  useEffect(() => {
    $.ajax({
      url: "https://platform.makemyhousegreen.com/connection/ajax/get/installer_pack",
      type: "POST",
      data: {
        kit_order_unique_identifier: id,
        long_sales_lead_unique_identifier: lsui,
      },
      success(response) {
        const responseJson = JSON.parse(response).data;
        const numberOfPanels = getNumberOfPanels(responseJson.roof_facings);
        setInstallerPack({
          ...responseJson,
          panel_number: numberOfPanels,
        });
      },
      error(error) {
        console.log(error);
      },
    });
  }, []);

  if (!installerPack) {
    return <div>Loading...</div>;
  }

  return (
    <div className="installer-pack container pt-3 pb-4 mb-5">
      <h4 className="my-3">Installer Pack</h4>
      <InstallerPackCard
        iconSrc="document"
        title="Customer Details"
        collapseId="customerDetails"
      >
        <InstallerPackField
          title="Name"
          value={`${installerPack.customer_first_name} ${installerPack.customer_surname}`}
        />
        <InstallerPackField
          title="Number"
          value={installerPack.customer_phone}
        />
        <InstallerPackField
          title="Address"
          value={installerPack.customer_address}
        >
          <p className="text-left ml-3 my-1">
            {installerPack.customer_postcode}
          </p>
        </InstallerPackField>
        <InstallerPackCustomerDetailsPhotos
          sitePlan={installerPack.site_plan_url}
          roofMeasurements={installerPack.roof_measurement_url}
          panelLayout={installerPack.panel_placement_url}
          optimiserLayout={installerPack.optismer_layout_url}
        />
      </InstallerPackCard>
      <InstallerPackCard iconSrc="solar-panel" title="Kit" collapseId="kit">
        <InstallerPackField value=" ">
          <ul className="text-left my-3 pr-4">
            {installerPack.solar_panels ? (
              <li>
                {`${installerPack.panel_number} x ${installerPack.panel_brand} ${installerPack.panel_name} solar panels`}
              </li>
            ) : null}
            {installerPack.inverter_name ? (
              <li>
                {`${installerPack.inverter_brand} ${installerPack.inverter_name} inverter`}
              </li>
            ) : null}
            {installerPack.solar_battery ? (
              <li>
                {`${installerPack.battery_brand} ${
                  installerPack.battery_name
                } ${
                  isMultipleBatteries(installerPack.battery_name)
                    ? "batteries"
                    : "battery"
                }`}
              </li>
            ) : null}
            {installerPack.ev_charger ? (
              <li>
                {`${installerPack.ev_charger_brand} ${installerPack.ev_charger_name} EV charger`}
              </li>
            ) : null}
            {installerPack.immersion_charger ? (
              <li>
                {`${installerPack.immersion_charger_brand} ${installerPack.immersion_charger_name} immersion charger`}
              </li>
            ) : null}
            {installerPack.optimisers ? (
              <li>{`${installerPack.optimisers} x optimisers`}</li>
            ) : null}
            {installerPack.pigeon_proofing ? (
              <li>Pigeon proofing (to be installed separately)</li>
            ) : null}
          </ul>
        </InstallerPackField>
      </InstallerPackCard>
      <InstallerPackCard iconSrc="book" title="Notes" collapseId="notes">
        <ul className="text-left my-3 pr-4">
          {installerPack.orderNotes.map((note, index) => (
            <li key={index}>{note}</li>
          ))}
        </ul>
      </InstallerPackCard>
      <InstallerPackCard iconSrc="house-leaf" title="Roof" collapseId="roof">
        <InstallerPackField
          title="Access Method"
          value={installerPack.access_method}
        />
        <InstallerPackField
          title="Loft Boarded"
          value={installerPack.loft_boarded}
        />
        <InstallerPackField title="Panel Type" value="JA Solar" />
        <hr className="mt-5 mb-4" />
        {installerPack.roof_facings?.map((item, index) => (
          <div key={index} className="mb-5">
            <h6 className="text-left my-5">
              <u>
                Roof Section
                {index + 1}
              </u>
            </h6>
            <InstallerPackField
              title="Number Of Panels"
              value={item.panel_count}
            />
            <InstallerPackField title="Facing Direction" value={item.azimuth} />
            <InstallerPackField title="Slope" value={item.slope} />
            <InstallerPackField title="Tile Type" value={item.tile_type} />
            <InstallerPackField
              title="Bracket Type"
              value={item.bracket_type}
            />
          </div>
        ))}
      </InstallerPackCard>
      <InstallerPackCard
        iconSrc="battery"
        title="Electrics"
        collapseId="electrics"
      >
        <InstallerPackField
          title="Fuseboard Brand(s)"
          value={installerPack.existing_fuseboard_brands}
        />
        <InstallerPackField
          title="Fuseboard Type"
          value={installerPack.existing_fuseboard_types}
        />
        <InstallerPackField
          title="Ancillary Fuseboard"
          value={installerPack.ancilliary_fuseboard ? "Yes" : "No"}
        />
        <InstallerPackField
          title="AC Cable Run Length"
          value={`${installerPack.ac_cable_run_length} Meters`}
        />
        <InstallerPackField
          title="AC Cable Route"
          value={installerPack.ac_cable_route}
        />
        <InstallerPackField
          title="Battery Location"
          value={installerPack.battery_location}
        />
        <InstallerPackField
          title="Inverter Location"
          value={installerPack.inverter_location}
        />
        <InstallerPackField
          title="Battery Mounting & Materials Required"
          value={installerPack.battery_mounting}
        />
        <InstallerPackField
          title="Inverter Mounting & Materials Required"
          value={installerPack.inverter_mounting}
        />
        <InstallerPackField
          title="EV Charger Location"
          value={installerPack.ev_charger_location}
        />
        <InstallerPackField
          title="Distance From EV Charger To Fuseboard"
          value={`${installerPack.ev_fuse_distance} Meters`}
        />
        <InstallerPackField
          title="Immersion Charger"
          value={installerPack.immersion_charger ? "Yes" : "No"}
        />
        <InstallerPackField
          title="Does Customer Want Smoke Alarm"
          value={installerPack.smoke_alarm ? "Yes" : "No"}
        />
        <InstallerPackField
          title="Inverter Export Settings"
          value="Please set inverter export settings to 3.68 kW using the G100 export limitation settings"
        />
      </InstallerPackCard>
      <InstallerPackCard
        iconSrc="tools"
        title="Scaffolding & Bird Proofing"
        collapseId="scaffoldingBirdProofing"
      >
        <InstallerPackField title="Panel Type" value="JA Solar" />
        {installerPack.scaffolding_sections?.map((item, index) => (
          <div key={index} className="my-5">
            <h6 className="text-left mb-4">
              <u>
                Scaffolding Section
                {index + 1}
              </u>
            </h6>
            <InstallerPackField
              title="Access Through House"
              value={item.access_through_house ? "Yes" : "No"}
            />
            <InstallerPackField
              title="Shrouding Required"
              value={item.shrouding_required ? "Yes" : "No"}
            />
            <InstallerPackField
              title="Distance From Van"
              value={`${item.distance_from_van} Meters`}
            />
            {item.obstacles ? (
              <InstallerPackField
                title="Obstacles"
                value={`${item.obstacles} Meters`}
              />
            ) : (
              ""
            )}
            <InstallerPackField title="Storeys" value={item.storeys_high} />
            <InstallerPackField
              title="Section Length"
              value={`${item.length} Meters`}
            />
          </div>
        ))}
      </InstallerPackCard>
      <InstallerPackCard
        iconSrc="camera"
        title="On Site Photos"
        collapseId="photos"
      >
        <InstallerPackPhotos onSitePhotos={installerPack.onsite_images} />
      </InstallerPackCard>
      <InstallerPackCard
        iconSrc="chat"
        title="Support Numbers"
        collapseId="numbers"
      >
        <InstallerPackField title="Solis" value=" ">
          <PhoneField number="+44 151 453 6515" callLink />
        </InstallerPackField>
        <InstallerPackField title="Pylon" value=" ">
          <PhoneField number="-" />
        </InstallerPackField>
        <InstallerPackField title="GivEnergy" value=" ">
          <PhoneField number="+44 1377 252 874" callLink />
        </InstallerPackField>
        <InstallerPackField title="Enphase" value=" ">
          <PhoneField number="01908 828928" callLink />
        </InstallerPackField>
        <InstallerPackField title="MyEnergy" value=" ">
          <PhoneField number="03333 001303" callLink />
        </InstallerPackField>
      </InstallerPackCard>
      <InstallerPackCard
        iconSrc="document-tick"
        title="Health & Safety"
        collapseId="healthSafety"
      >
        <HealthSafetyCard title="Roof access">
          <HealthSafetyTemplate
            hazard="Working at heights"
            peopleExposed="Site operatives"
            howAffected="Risk of injury through falls"
            actions="Use of appropriate, safe access solution to the roof, e.g. scaffolding, access platform."
          />
        </HealthSafetyCard>
        <HealthSafetyCard title="Scaffolding">
          <HealthSafetyTemplate
            hazard="Working at heights"
            peopleExposed="Site operatives"
            howAffected="Risk of injury through falls"
            actions="Scaffolding equipped with double guards and toe rails.
            Edge protection in place to at least 2m either side of working area.
            If no space for this then gable end edge protection in place.
            Safety harnesses used where appropriate."
          />
          <hr className="my-5" />
          <HealthSafetyTemplate
            hazard="Scaffold failure"
            peopleExposed="Site operatives, Civilians on site"
            howAffected="Risk of scaffolding failure leading to fail / injury"
            actions="Check scaffolding is tagged and within date. Inspection of scaffold condition before using. Ground underneath scaffolding is stable."
          />
          <hr className="my-5" />
          <HealthSafetyTemplate
            hazard="Moving kit to roof"
            peopleExposed="Site operatives"
            howAffected="Risk of injury through lifting or dropping kit"
            actions="Suitable lifting equipment in place e.g. hoist. Equipment has automatic brake in place.
            Equipment has been inspected for damage before use.
            Safe working load of equipment never exceeded.
            Loading / unloading does not place workers at risk."
          />
          <hr className="my-5" />
          <HealthSafetyTemplate
            hazard="Kit falling from scaffold"
            peopleExposed="Site operatives, Civilians on site"
            howAffected="Risk of injury from falling kit"
            actions="Hard hats worn on site at all times.
            Awareness of risk when underneath scaffold. Loose items not left on platform unattended."
          />
        </HealthSafetyCard>
        <HealthSafetyCard title="Access platform (easy-deck)">
          <HealthSafetyTemplate
            hazard="Working at heights"
            peopleExposed="Site operatives"
            howAffected="Risk of injury through falls"
            actions="Platform has edge protection in place."
          />
          <hr className="my-5" />
          <HealthSafetyTemplate
            hazard="Platform failure"
            peopleExposed="Site operatives"
            howAffected="Risk of platform failure"
            actions="Inspect platform condition / assembly prior to use. Ground under platform is stable. Safe working load of platform is not exceeded."
          />
          <hr className="my-5" />
          <HealthSafetyTemplate
            hazard="Kit falling from platform"
            peopleExposed="Site operatives, Civilians on site"
            howAffected="Risk of injury from falling kit"
            actions="Hard hats worn on site at all times. Awareness of risk when underneath scaffold"
          />
          <hr className="my-5" />
          <HealthSafetyTemplate
            hazard="Moving kit to roof level"
            peopleExposed="Site operatives"
            howAffected="Risk of injury through lifting or dropping kit"
            actions="Suitable lifting equipment in place e.g. hoist. Equipment has automatic brake in place. Equipment has been inspected for damage before use. Safe working load of equipment never exceeded. Loading / unloading does not place workers at risk."
          />
        </HealthSafetyCard>
        <HealthSafetyCard title="Electricity">
          <HealthSafetyTemplate
            hazard="Electric shock"
            peopleExposed="Site operatives"
            howAffected="Risk of receiving an electric shock"
            actions="Electrical work carried out by qualified electrician. Turn off and isolate electricity to the working areas. Test that wires are de-energised in working areas. Where not possible to isolate electricity suitable ARC rated protective equipment worn and measures taken to avoid exposure to live wires and cables."
          />
          <hr className="my-5" />
          <HealthSafetyTemplate
            hazard="Overhead power lines"
            peopleExposed="Site operatives"
            howAffected="Risk of shock from overhead lines"
            actions="Maintain minimum 10m distance from power lines at all times."
          />
        </HealthSafetyCard>
        <HealthSafetyCard title="General site safety">
          <HealthSafetyTemplate
            hazard="Trip hazards"
            peopleExposed="Site operatives, Civilians on site"
            howAffected="Risk of injury through fall due to trip"
            actions="Site kept clear of trip hazards"
          />
          <hr className="my-5" />
          <HealthSafetyTemplate
            hazard="General injury"
            peopleExposed="Site operatives"
            howAffected="Risk of injury from abrasion"
            actions="Wear suitable PPE at all times."
          />
          <hr className="my-5" />
          <HealthSafetyTemplate
            hazard="Fire risk"
            peopleExposed="Site operatives, Civilians on site"
            howAffected="Risk of fire on site"
            actions="Careful handling of flammable materials. Fire extinguishers kept on site at all times. Clear fire evacuation plan."
          />
          <hr className="my-5" />
          <HealthSafetyTemplate
            hazard="Manual handling"
            peopleExposed="Site operatives"
            howAffected="Risk of injury from lifting heavy equipment"
            actions="All operatives trained in manual handling techniques. Safe manual handling limits (>25kg) not exceeded."
          />
          <hr className="my-5" />
          <HealthSafetyTemplate
            hazard="Lighting"
            peopleExposed="Site operatives"
            howAffected="Risk of injury in poor lighting conditions"
            actions="Ensure site is appropriately lit at all times."
          />
        </HealthSafetyCard>
      </InstallerPackCard>
    </div>
  );
}

function getNumberOfPanels(roofFacings) {
  return roofFacings?.reduce((acc, curr) => acc + curr.panel_count, 0);
}

function isMultipleBatteries(batteryName) {
  return batteryName?.includes("+") || batteryName?.includes("x");
}

export default InstallerPack;
